export const ar = {
  welcome: 'مرحبًا',
  logout: 'تسجيل الخروج',
  trading_accounts: 'حسابات التداول',
  account_list: 'قائمة الحسابات',
  create_live_account: 'إنشاء حساب حقيقي',
  upgrade_to_live_account: 'الترقية إلى حساب حقيقي',
  create_demo_account: 'إنشاء حساب تجريبي',
  finance: 'المالية',
  deposit_funds: 'إيداع الأموال',
  withdraw_funds: 'سحب الأموال',
  internal_transfer: 'تحويل داخلي',
  external_transfer: 'تحويل خارجي',
  transfer_back: 'تحويل مرة أخرى',
  transfer_back_to_my_local_depositor: 'التحويل مرة أخرى إلى المودع المحلي الخاص بي',
  transfer_to_external_account: 'التحويل لحساب خارجي',
  payment_history: 'تاريخ الدفع',
  my_cards: 'بطاقاتي',
  my_profile: 'ملفي الشخصي',
  personal_information: 'معلومات شخصية',
  change_password: 'تغيير كلمة المرور',
  upload_documents: 'تحميل المستندات',
  partner: 'شريك',
  overview: 'نظرة عامة',
  clients: 'العملاء',
  sub_ibs: 'الوسطاء المعرفون الفرعيون',
  payout: 'المدفوعات',
  marketing_material: 'المواد التسويقية',
  withdrawal_history: 'تاريخ السحب',
  become_a_partner: 'كن شريكًا',
  please_fill_the_following_fields: 'يرجى ملء الحقول التالية',
  what_geographic_region: 'ما المنطقة الجغرافية التي ستستهدفها بشكل أساسي؟',
  submit: 'تقديم',
  upload_documents_notice: "من أجل الموافقة الكاملة على حسابك ولكي تكون قادرًا على التداول، <a dir='rtl'>يرجى تحميل المستندات الخاصة بك</a> وإكمال ملفك الشخصي",
  change_password_ta_notice: 'أي حساب تداول جديد سيستخدم كلمة مرورك الجديدة. هذا لا يؤثر على حسابات التداول الحالية الخاصة بك.',
  changepass_error: 'كلمة المرور الحالية خاطئة، يرجى المحاولة مرة أخرى.',
  changepass_success: 'تم تغيير كلمة المرور بنجاح',
  current_password: 'كلمة المرور الحالية',
  new_password: 'كلمة المرور الجديدة',
  confirm_new_password: 'تأكيد كلمة المرور الجديدة',
  pending_account: 'حساب معلق',
  account_must_be_approved_message: 'يجب الموافقة على حسابك قبل إنشاء حساب تداول حقيقي جديد.',
  new_trading_account_message: 'تم إنشاء حساب تداول جديد بنجاح',
  password_generated_for_ta: 'تم إنشاء كلمة مرور وإرسالها إلى بريدك الإلكتروني لحساب التداول الجديد الخاص بك',
  new_trading_account_type_message: 'تم إنشاء حساب تداول جديد {type} بنجاح',
  choose_your_desired_trading_platform_and_settings: 'اختر منصة التداول والإعدادات التي تريدها',
  select_leverage: 'حدد الرافعة المالية',
  create: 'إنشاء',
  select_account_type: 'حدد نوع الحساب',
  select_currency: 'اختر العملة',
  no_trading_account_found: 'لم يتم العثور على حساب تداول.',
  bankwire_notice:
    "شكرًا لك على تقديم التفاصيل المصرفية الخاصة بك. سنقوم بتسجيل بياناتك مع مصرفنا.<br/><br/>ستتلقى تفاصيل التحويل الإلكتروني عبر البريد الإلكتروني في غضون 24 ساعة إلى جانب مرجع الدفع الشخصي الخاص بك. يمكنك استخدام هذه التفاصيل لأي ودائع مستقبلية.<br/><br/><strong dir='rtl'>هام:</strong> مرجع الدفع مخصص لعميل واحد. إذا لم تستخدم مرجع الدفع الذي تلقيته، فلن نتمكن من قبول إيداعك. لا يمكن لأطراف ثالثة استخدام نفس مرجع الدفع.",
  deposit: 'إيداع',
  account_details: 'تفاصيل الحساب',
  enter_fasapay_id: 'يرجى إدخال معرف حساب Fasapay الخاص بك:',
  account_id: 'معرف الحساب',
  secure_id: 'معرف آمن',
  continue: 'متابعة',
  // bankwire_details_notice: 'Our bank requires your bank details in order to process your deposit. Any deposits made via Wire Transfer will be returned to the same account from which you deposited.',
  bankwire_deposit_details_notice:
    'يطلب مصرفنا التفاصيل المصرفية الخاصة بك من أجل معالجة إيداعك. سيتم إرجاع أي إيداعات تتم عن طريق التحويل المصرفي إلى نفس الحساب الذي قمت بالإيداع منه.',
  bankwire_withdrawal_details_notice:
    'يطلب مصرفنا التفاصيل المصرفية الخاصة بك من أجل معالجة عملية السحب. سيتم إرجاع أي عمليات سحب تم إجراؤها عبر التحويل المصرفي إلى نفس الحساب الذي قمت بالإيداع منه.',
  bankwire_verify_account_notice:
    '<p dir="rtl">تحتاج إلى التحقق من حسابك قبل استخدام "التحويل البنكي". يرجى <a href="{FSROOT_URL}upload-documents" dir="rtl">تحميل المستندات الخاصة بك</a></p>',
  bankwire_amount_label: 'المبلغ ({minDeposit} الحد الأدنى للإيداع)',
  bank_name: 'اسم المصرف',
  full_name: 'الاسم بالكامل',
  deposit_methods: 'طرق الإيداع',
  deposit_select_ta_p: 'يرجى تحديد حساب التداول الذي ترغب في إيداع الأموال فيه:',
  coming_soon: 'قريبًا',
  amount: 'المبلغ',
  proof_of_id: 'إثبات الهوية',
  proof_of_id_instructions: 'إثبات الهوية',
  documents_must_contain_all_of_the_following_details: 'يجب أن تستوفي المستندات المتطلبات التالية:',
  your_full_name: 'اسمك بالكامل',
  a_unique_id_number: 'رقم معرف فريد',
  your_birthdate: 'تاريخ ميلادك',
  your_place_of_birth: 'مكان ميلادك',
  a_visible_photo: 'صورة مرئية',
  your_signature: 'توقيعك',
  your_nationality: 'جنسيتك',
  proof_of_residence_instructions: 'يرجى تحميل فاتورة المرافق أو كشف الحساب المصرفي.',
  your_residential_address: 'عنوان إقامتك',
  date_of_issue: 'تاريخ الإصدار',
  other: 'غير ذلك',
  other_documents_instructions: 'المستندات الأخرى التي طلبها قسم التحقق لدينا.',
  deposit_failed: 'فشل الإيداع',
  deposit_successful: 'إيداع ناجح',
  already_logged_in: 'قمت بتسجيل الدخول بالفعل',
  login: 'تسجيل الدخول',
  create_an_account: 'إنشاء حساب',
  partner_clients: 'شريك - عملاء',
  trades: 'الصفقات',
  client_id: 'معرف العميل',
  trading_account: 'حساب التداول',
  platform: 'المنصة',
  order: 'الأمر',
  pair: 'الزوج',
  volume: 'الحجم',
  close_date: 'تاريخ الإغلاق',
  commission: 'العمولة',
  status: 'الحالة',
  total_commission_generated: 'إجمالي العمولة المنشأة',
  total_deposits: 'إجمالي عمليات الإيداع',
  total_withdrawals: 'إجمالي عمليات السحب',
  date_joined: 'تاريخ الانضمام',
  more: 'المزيد',
  banners: 'لافتات',
  partner_marketing_material: 'شريك - مواد تسويقية',
  partner_overview: 'شريك - نظرة عامة',
  partner_payout: 'شريك - الدفع',
  partner_payout_request_message: 'تم تسجيل طلبك.',
  select_your_default_payment_option: 'حدد خيار الدفع الافتراضي الخاص بك:',
  beneficiary_name_on_account: 'المستفيد (الاسم على الحساب)',
  bank_address: 'عنوان المصرف',
  sorty_code_if_applicable: 'كود الفرز (إن وجد)',
  your_provider_email: 'بريدك {provider} الإلكتروني',
  select: 'تحديد',
  next: 'التالي',
  please_confirm_your_bank_details: 'يرجى تأكيد التفاصيل المصرفية الخاصة بك:',
  bank: 'المصرف',
  sub_partners: 'الشركاء الفرعيون',
  state: 'الدولة',
  date: 'التاريخ',
  internal_transfer_instructions:
    'يمكنك تحويل الأموال بين حسابات التداول الخاصة بك.<br/>يرجى إدخال مبلغ التحويل المطلوب وتحديد حسابات المصدر والوجهة. تتم معالجة التحويلات الداخلية<br/>على الفور.',
  transfer_complete: 'اكتمل التحويل',
  transfer_from: 'تحويل من',
  internal_transfer_processed_successfully: 'تمت معالجة التحويل الداخلي بنجاح.',
  external_transfer_processed_successfully: 'تمت معالجة التحويل الخارجي بنجاح.',
  select_account: 'حدد حساب',
  to: 'إلى',
  warning_currency_convertion_will_take_place: 'تحذير: سيتم تحويل العملة',
  transfer: 'تحويل',
  account: 'الحساب',
  currency: 'العملة',
  balance: 'الرصيد ',
  equity: 'رأس المال',
  download: 'تنزيل',
  launch: 'بدء',
  email: 'البريد الإلكتروني',
  password: 'كلمة المرور',
  forgot: 'نسيت',
  forgot_password: 'نسيت كلمة المرور',
  risk_warning_footer:
    'تحذير من المخاطر: قد لا يكون تداول المنتجات ذات الرافعة المالية مثل الفوركس والعقود مقابل الفروقات مناسبًا لجميع المستثمرين لأنها تنطوي على درجة من المخاطرة برأس المال الخاص بك. يرجى التأكد من فهمك الكامل للمخاطر التي تنطوي عليها، مع مراعاة أهداف استثماراتك ومستوى خبرتك، قبل التداول، وإذا لزم الأمر، اطلب مشورة مستقلة. يرجى قراءة <a href="{riskURL}" dir="rtl">بيان المخاطر</a> بالكامل.',
  error_contact_support: 'حدث خطأ ما، يرجى الاتصال بالدعم.',
  type: 'النوع',
  funded: 'ممول',
  username: 'اسم االمستخدم',
  company_name: 'اسم الشركة',
  website: 'الموقع الإلكترونى',
  first_name: 'الاسم الأول',
  last_name: 'الاسم الأخير',
  date_of_birth: 'تاريخ الميلاد',
  gender: 'الجنس',
  phone: 'الهاتف',
  dial_code: 'كود الاتصال الهاتفي',
  country: 'البلد',
  address: 'العنوان',
  year_moved_to_address: 'تم نقل السنة إلى العنوان',
  post_code: 'الرمز البريدي',
  selected_currency: 'العملة المحددة',
  january: 'يناير',
  february: 'فبراير',
  march: 'مارس',
  april: 'أبريل',
  may: 'مايو',
  june: 'يونيو',
  july: 'يوليو',
  august: 'أغسطس',
  september: 'سبتمبر',
  october: 'أكتوبر',
  november: 'نوفمبر',
  december: 'ديسمبر',
  already_have_an_account: 'لديك حساب بالفعل',
  invalid_request_login_required: 'طلب غير صالح، تحتاج إلى تسجيل الدخول أولاً.',
  register_accounttype_account: 'تسجيل حساب {accountType}',
  client_type: 'نوع العميل',
  individual: 'فردي',
  company: 'شركة',
  company_information: 'معلومات الشركة',
  company_website: 'الموقع الإلكتروني للشركة',
  complete_live_registration: 'استكمال التسجيل المباشر',
  title: 'العنوان',
  confirm_password: 'تأكيد كلمة المرور',
  select_country: 'حدد البلد',
  phone_number: 'رقم الهاتف',
  choose_trading_platform: 'اختر منصة التداول',
  select_option: 'حدد الخيار',
  day: 'اليوم',
  month: 'الشهر',
  year: 'السنة',
  company_registration_information: 'معلومات تسجيل الشركة',
  date_of_registration: 'تاريخ التسجيل',
  select_nationality: 'تحديد الجنسية',
  nationality: 'الجنسية',
  select_gender: 'تحديد نوع الجنس',
  male: 'ذكر',
  female: 'أنثى',
  address_line: 'سطر العنوان',
  city_town: 'المدينة/البلد',
  state_province: 'الولاية/المقاطعة',
  select_year: 'تحديد عام',
  year_moved_to_current_address: 'تم نقل السنة إلى العنوان الحالي',
  company_shareholders_directors: 'مساهمو الشركة ومديروها',
  number_of_shareholders: 'عدد المساهمين',
  number_of_directors: 'عدد أعضاء مجلس الإدارة',
  shareholder: 'المساهم',
  financial_information: 'معلومات مالية',
  total_estimated_net_worth: 'إجمالي القيمة الصافية المقدرة (€)؟',
  less_than_amount: 'أقل من {amount}',
  over_amount: 'أكثر من {amount}',
  total_estimated_annual_income: 'إجمالي الدخل السنوي المقدر (€)؟',
  employment_information: 'معلومات التوظيف',
  employment_status: 'الحالة الوظيفية',
  employed: 'يعمل',
  self_employed: 'العاملون لحسابهم الخاص',
  retired: 'متقاعد',
  student: 'طالب',
  unemployed: 'عاطل عن العمل',
  source_of_income: 'مصدر الدخل',
  employment: 'توظيف',
  inheritance: 'ميراث',
  investment: 'استثمار',
  trading_experience: 'خبرة التداول',
  forex_cfds_and_other_instruments: 'الفوركس، والعقود مقابل الفروقات والأدوات الأخرى',
  yes: 'نعم',
  no: 'لا',
  lose_capital_risk:
    'المنتجات المشتقة مناسبة كجزء من أهدافي الاستثمارية وموقفي تجاه المخاطر وأنا قادر على تقييم المخاطر التي ينطوي عليها تداولها، بما في ذلك احتمال أن أفقد كل رأس مالي',
  prev_pro_qualifications: 'لدي مؤهلات مهنية سابقة و/أو خبرة عمل في مجال الخدمات المالية',
  account_type: 'نوع الحساب',
  choose_currency: 'اختر العملة',
  tos_with_link: 'لقد قرأت وفهمت وقبلت الشروط والأحكام وبيان التحذير من المخاطر <a target="_blank" href="{URL}" dir="rtl">هنا</a>',
  registration_successful: 'التسجيل ناجح',
  reset_password_invalid_link: 'رابط إعادة التعيين غير صالح، يرجى المحاولة مرة أخرى أو الاتصال بالدعم.',
  reset_account_password: 'إعادة تعيين كلمة مرور الحساب',
  choose_your_new_password: 'اختر كلمة المرور الجديدة',
  reset_password: 'إعادة تعيين كلمة المرور',
  file_upload_failed_filename: 'تعذر {filepath} طلب تحميل الملف.',
  withdrawal_request_success_message: 'لقد كان طلب السحب الخاص بك ناجحًا',
  withdraw: 'السحب',
  please_fill_the_following: 'يرجى ملء ما يلي',
  cancel: 'إلغاء',
  withdraw_select_ta_p: 'يرجى تحديد حساب التداول الذي ترغب في السحب منه:',
  free_margin_change_warning: 'يرجى ملاحظة أن السحب يجب أن يتم بنفس الطريقة التي أودعت بها في حسابك.',
  you_need_an_ib_account_to_visit_this_page: 'أنت بحاجة إلى حساب وسيط معرف لزيارة هذه الصفحة',
  no_permission_to_to_visit_this_page: 'ليس لديك إذن لزيارة هذه الصفحة',
  you_became_a_partner_successfully: 'لقد أصبحت شريكًا في EUROTRADER بنجاح!',
  note_wallet_currency_conversion_partner:
    'يرجى ملاحظة أنه عندما تصبح شريكًا، سيتم تغيير عملة محفظتك إلى الدولار الأمريكي وسيتم تحويل أي أموال حالية إلى الدولار الأمريكي بسعر الصرف الحالي!',
  upgraded_to_a_live_account_successfully: 'تمت الترقية إلى حساب حقيقي بنجاح!',
  passwords_dont_match: 'كلمات المرور غير متطابقة',
  password_rules: 'ما لا يقل عن حرف كبير وحرف صغير ورقم واحد (من 6 إلى 16 حرفًا كحد أقصى)',
  please_fill: 'من فضلك املأ',
  partner_verify_first_notice: 'لتصبح شريكًا، عليك إتمام التحقق من حسابك أولاً. يرجى تحميل المستندات الخاصة بك <a href="upload-documents" dir="rtl">هنا</a>',
  only_currency_format_allowed: 'يسمح فقط بتنسيق العملة',
  please_enter_your_account_id: 'يرجى إدخال معرف حسابك',
  min_deposit_with_bankwire_is_amount: 'يبلغ الحد الأدنى للإيداع مع bankwire {amount}',
  please_select_different_tas: 'يرجى تحديد حسابات تداول مختلفة',
  you_need_to_accept_our_tos: 'أنت بحاجة إلى قبول الشروط والأحكام الخاصة بنا.',
  phone_is_required: 'الهاتف مطلوب',
  invalid_phone_number: 'رقم الهاتف غير صحيح',
  you_must_be_over_18: 'يجب أن يكون عمرك أكبر من 18 عامًا.',
  year_is_required: 'السنة مطلوبة',
  leave_page_question: 'هل ستغادر الصفحة؟',
  registration_exit_notice: 'لم تنتهِ من تسجيلك بعد. هل تريد في المغادرة دون الانتهاء؟',
  internal_server_error_support: 'خطأ داخلي في الخادم. يرجى الاتصال بالدعم',
  please_fill_all_fields: 'يرجى ملء جميع الحقول',
  no_logs_found_for_this_client: 'لم يتم العثور على سجلات لهذا العميل',
  no_accounts_send: 'لا يتم إرسال حسابات',
  internal_server_error_try_again: 'خطأ داخلي في الخادم. يرجى المحاولة مرة أخرى لاحقًا',
  insufficient_balance: 'رصيد غير كاف',
  currency_conversion_connection_error: 'لا توجد استجابة من خادم تحويل العملات، يرجى المحاولة مرة أخرى أو الاتصال بالدعم.',
  currency_conversion_error: 'خطأ في تحويل العملات، يرجى المحاولة مرة أخرى أو الاتصال بالدعم.',
  invalid_accounts: 'حسابات غير صالحة',
  withdrawal_unsuccessful_equity_message: 'عملية السحب غير ناجحة، لا يوجد رصيد كافٍ في حساب التداول {TAID}',
  withdrawal_failed_free_margin: 'تعذر السحب. يرجى التحقق مرة أخرى من الهامش المجاني الخاص بك.',
  pamm_copy_server_field_message: 'يرجى نسخ عنوان IP ولصقه في حقل "الخادم" في خادم MT4 الخاص بك',
  invalid_request: 'طلب غير صالح',
  missing_shareholders_directors: 'المساهمون/المدراء المفقودون',
  missing: 'مفقود',
  invalid_request_passwords_do_not_match: 'طلب غير صالح. كلمات المرور غير مطابقة',
  email_exists_message: 'البريد الإلكتروني موجود، يرجى المحاولة باستخدام عنوان بريد إلكتروني آخر.',
  your_payment_method_has_already_been_set: 'تم بالفعل تعيين طريقة الدفع الخاصة بك. يرجى الاتصال بالدعم',
  payment_method_is_required_message: 'طريقة الدفع مطلوبة. يرجى المحاولة مرة أخرى أو الاتصال بالدعم',
  couldnt_find_your_account: 'تعذر العثور على حسابك',
  ta_limit_error_message: 'وصل حسابك إلى حد حسابات التداول({limit}) لـ {platform}.',
  error: 'خطأ',
  account_created_successfully: 'تم إنشاء الحساب بنجاح',
  invalid_leverage: 'رافعة غير صالحة',
  insufficient_data_provided: 'البيانات المقدمة غير كافية',
  insufficient_data_provided_missing_field: 'البيانات المقدمة غير كافية. {field} مفقود.',
  invalid_amount: 'مبلغ غير صالح',
  account_taid_doesnt_exist: 'الحساب {TAID} غير موجود',
  withdrawal_unsuccessful_equity_taid: 'عملية السحب غير ناجحة، لا يوجد رصيد كافٍ في حساب التداول {TAID}',
  withdrawal_unsuccessful_free_margin_taid: 'عملية السحب غير ناجحة، لا يوجد هامش حر كافي على حساب التداول {TAID}',
  internal_server_error: 'خطأ في الخادم الداخلي',
  deposit_failed_support: 'لم ينجح الإيداع، يرجى الاتصال بالدعم.',
  upload_documents_instructions: 'يرجى تزويدنا بالمستندات التالية.<br/>يجب أن تكون الملفات بتنسيق PDF أو JPG أو PNG ويجب ألا يتجاوز حجمها 5 ميجا بايت.',
  total_earned: 'إجمالي الأرباح المكتسبة',
  total_paid: 'مجموع المبالغ المدفوعة',
  total_clients: 'إجمالي العملاء',
  total_sub_ibs: 'إجمالي الوسطاء المعرفون من الباطن',
  see_trading_accounts: 'اطلع على حسابات التداول',
  see_trades: 'اطلع على الصفقات',
  welcome_title_live: 'شكرًا لفتح حسابك مع EUROTRADER!',
  welcome_title_demo: 'شكرًا لك على فتح حسابك التجريبي مع EUROTRADER!',
  welcome_title_ib: 'شكرًا لك على فتح حساب الشركاء الخاص بك مع EUROTRADER!',
  welcome_text_live:
    '<p dir="rtl">للحصول على التمويل والموافقة والاستعداد للتداول، عليك إكمال الخطوات التالية:</p><ul dir="rtl"><li dir="rtl">سجّل الدخول إلى بوابة عميل Eurotrader</li><li dir="rtl">قم بتحميل المستندات الخاصة بك</li><li dir="rtl">قم بتمويل حسابك</li><li dir="rtl">ابدأ التداول!</li></ul><p dir="rtl">إذا كنت بحاجة إلى أي مساعدة، فإن فريق دعم العملاء الودود لدينا متاح على مدار الساعة طوال أيام الأسبوع. للاتصال بهم، انقر <a href="{contactURL}" target="_blank" dir="rtl">هنا</a></p>',
  welcome_text_demo:
    '<p dir="rtl">للحصول على التمويل والموافقة والاستعداد للتداول، عليك إكمال الخطوات التالية:</p><ul dir="rtl"><li dir="rtl">قم بتنزيل منصة MT4</li><li dir="rtl">اختبر مهاراتك في التداول وسرعاتنا في التنفيذ</li><li dir="rtl">قم بتسجيل الدخول إلى بوابة العميل الخاصة بك وقم بالترقية إلى حساب حقيقي</li><li dir="rtl">قم بتحميل المستندات الخاصة بك وقم بتمويل حسابك</li><li dir="rtl">تداول في أكبر سوق مالي في العالم!</li></ul><p dir="rtl">إذا كنت بحاجة إلى أي مساعدة، فإن فريق دعم العملاء الودود لدينا متاح على مدار الساعة طوال أيام الأسبوع. للاتصال بهم، انقر <a href="{contactURL}" target="_blank" dir="rtl">هنا</a></p>',
  welcome_text_ib:
    '<p dir="rtl">لكي تتم الموافقة على حساب الشركاء الخاص بك ويكون جاهزًا لتلقي عنوان URL للإحالة الخاص بك، يلزمك إكمال الخطوات التالية:</p><ul dir="rtl"><li dir="rtl">قم بتسجيل الدخول إلى بوابة العميل الخاصة بك</li><li dir="rtl">قم بتحميل المستندات الخاصة بك</li><li dir="rtl">احصل على عنوان URL للتتبع في قسم "نظرة عامة" و "أدوات التسويق"</li><li dir="rtl">قم بإحالة عملائك واحصل على عمولة!</li></ul><p dir="rtl">إذا كنت بحاجة إلى أي مساعدة، فإن فريق دعم العملاء الودود لدينا متاح على مدار الساعة طوال أيام الأسبوع. للاتصال بهم، انقر <a href="{contactURL}" target="_blank" dir="rtl">هنا</a></p>',
  bankwire_passports_notice: 'هام: مطلوب جوازات سفر كدليل على الهوية من أجل إجراء تحويل مصرفي.',
  tracking_links: 'روابط التتبع',
  proof_of_residence: 'دليل الإقامة',
  login_to_your_account: 'تسجيل الدخول إلى<br/>حسابك',
  register: 'تسجيل',
  open_demo_account: 'فتح حساب تجريبي',
  create_partner_account: 'إنشاء حساب شريك',
  page_title_partner: 'كن شريكًا | Eurotrader',
  ib_payout_msg_monthly_payment: 'يتم إجراء المدفوعات نصف شهريًا بالطريقة التي تختارها. سيتم إجراء المدفوعات في يوم العمل 15 و1 من كل شهر.',
  payout_selection_complete: 'تم اختيار طريقة الدفع.',
  home: 'الصفحة الرئيسية',
  about: 'نبذة عن',
  account_types: 'أنواع الحسابات',
  spreads: 'فروق الأسعار',
  funding: 'التمويل',
  education: 'التعليم',
  contact: 'الاتصال',
  forex_broker: 'وسيط فوركس',
  services_provided_by: 'الخدمات المالية التي تقدمها Eurotrade Global Ltd',
  footer_certificate_eurotrader:
    '<a href="https://eservices.cipc.co.za/Search.aspx" style="color: #e04ef8; text-decoration: underline" target="_blank" dir="rtl">Eurotrade SA (Pty) Ltd</a> ("Eurotrader") هي شركة تابعة لشركة Eurotrade RGB Holdings Ltd (HE367109) ومزود خدمات مالية مرخص ومنظم من قبل هيئة سلوك القطاع المالي (FSCA) في الجنوب أفريقيا برقم ترخيص FSP <a href="https://www.fsca.co.za/Fais/Search_FSP.htm" style="color: #e04ef8; text-decoration: underline" target="_blank" dir="rtl">44351</a> بعنوان مسجل في 74 Walmer street, Sydenham, Johannesburg, 2192, South Africa.<br/><br/><!-- "Eurotrader" هي علامة تجارية مسجلة لشركة Eurotrade Investments RGB Ltd، شركة استثمار قبرصية (CIF) تحت رقم التسجيل HE317893، مرخصة ومنظمة من قبل هيئة الأوراق المالية والبورصة القبرصية (CySEC) بموجب ترخيص 279/15 مع عنوان مسجل في  70, Kyrillou Loukareos Street, Kakos Premier Tower, 1st Floor, 4156 Limassol, Cyprus. سيتم إكمال معالجة البطاقة بواسطة Eurotrade Investments RGB Ltd.<br /><br /> -->Eurotrader does not provide services to residents of certain jurisdictions including the USA, Iran, Canada, the Democratic Republic of Korea, Belgium, Japan, and is not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation.<br /><br />Eurotrade SA (PTY) Ltd does not actively target EU clients.',
  footer_risk_warning:
    'قد لا يكون تداول المنتجات ذات الرافعة المالية مثل الفوركس والعقود مقابل الفروقات مناسبًا لجميع المستثمرين لأنها تنطوي على درجة من المخاطرة برأس المال الخاص بك. يرجى التأكد من فهمك الكامل للمخاطر التي تنطوي عليها، مع مراعاة أهداف استثماراتك ومستوى خبرتك، قبل التداول، وإذا لزم الأمر، اطلب مشورة مستقلة. <a href="https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Risk%20Disclosure.pdf" style="color: #e04ef8; text-decoration: underline" target="_blank" dir="rtl">يرجى قراءة بيان المخاطر بالكامل.</a>',
  open_live_account: 'فتح حساب حقيقي',
  not_registered_with_question: 'هل أنت غير مسجل في Eurotrader؟',
  forgot_password_q: 'هل نسيت كلمة المرور؟',
  pending_deposit_success: 'نجحت العملية، إيداعك في انتظار الموافقة الآن',
  your_card_will_be_charged_cny: "سيتم فرض رسوم على بطاقتك <b dir='rtl'>{amount}</b> يوان صيني",
  currency_conversion_info: 'معلومات تحويل العملات',
  min_deposit_is_amount: 'الحد الأدنى للإيداع هو {amount}',
  min_transfer_is_amount: 'الحد الأدنى للتحويل هو {amount}',
  local_depositor: 'المودع المحلي',
  converted_amount: 'المبلغ المحول',
  from_currency: 'من العملة',
  to_currency: 'للعملة',
  reference_id: 'الرقم المرجعي',
  from_account: 'من حساب',
  to_account: 'لحساب',
  from_date: 'من تاريخ',
  to_date: 'حتى تاريخ',
  target_account_id: 'معرف الحساب المستهدف',
  wallet: 'المحفظة',
  received: 'تم الاستلام',
  send: 'إرسال',
  sender_not_a_transfer_account: 'المرسل ليس مودعًا محليًا',
  withdrawal_failed_support: 'لم تنجح عملية السحب، يرجى الاتصال بالدعم.',
  clear: 'صافي',
  transfer_completed_successfully: 'اكتمل التحويل بنجاح',
  receive: 'استلام',
  view_trades: 'عرض الصفقات',
  your_provider_account_number: 'رقم حسابك {provider}',
  your_bitcoin_address: 'عنوان البيتكوين الخاص بك',
  your_crypto_address: 'عنوان {crypto} الخاص بك',
  destination_tag: 'علامة الوجهة',
  change_trading_account_password: 'تغيير كلمة مرور حساب التداول',
  your_card_will_be_charged_thb: "سيتم شحن بطاقتك <b dir='rtl'>{amount}</b> THB",
  dashboard: 'لوحة القيادة',
  sent: 'تم الإرسال',
  client_state_approved: 'تمت الموافقة',
  client_state_pending: 'معلقة',
  client_state_incomplete: 'غير مكتملة',
  open_trades: 'الصفقات المفتوحة',
  trade_history: 'تاريخ التداول',
  search_trades: 'البحث عن الصفقات',
  trade_no: 'التداول رقم',
  symbol: 'الرمز',
  open_price: 'سعر الفتح',
  close_price: 'سعر الإغلاق',
  datetime: 'التاريخ والوقت',
  my_bonuses: 'العمولات الخاصة بي',
  bonus: 'العمولة',
  conversion_progress: 'تقدم التحويل',
  front_of_id: 'واجهة بطاقة الهوية',
  back_of_id: 'الجزء الخلفي لبطاقة الهوية',
  include_account_in_bonus_program: 'أرغب في الانضمام إلى برنامج التداول الممول بنسبة 111%.',
  invest_under_master_account: 'استثمر تحت حساب رئيسي',
  i_accept_the_terms_of_service: 'أوافق على شروط الخدمة',
  pamm_master_locks_withdrawals: '[يقيد PAMM Master عمليات السحب خلال الصفقات المفتوحة!]',
  open_p_l: 'فتح الربح والخسارة',
  p_l: 'الربح والخسارة',
  gains_prc: 'أرباح %',
  max_drawdown: 'الحد الأقصى للتخفيض',
  bonus_tos_with_link: 'لقد قرأت وفهمت <a target="_blank" href="{URL}" dir="rtl">شروط وأحكام برنامج التداول الممول بنسبة 111%</a>.',
  i_am_over_18: 'أقر بأن عمري يزيد على 18 (ثمانية عشر) عامًا لفتح هذا الحساب.',
  all_time: 'كل وقت',
  last_month: 'الشهر الماضي',
  last_week: 'الأسبوع الماضي',
  last_3_days: 'آخر 3 أيام',
  monthly_avg: 'المتوسط الشهري',
  profit: 'الربح',
  create_and_attach: 'إنشاء وإرفاق',
  attach: 'إرفاق',
  create_and_attach_new_pamm_account: 'إنشاء وإرفاق حساب PAMM جديد',
  select_a_pamm_account_to_attach: 'حدد حساب PAMM لإرفاقه',
  enter_private_code: 'أدخل الرمز الخاص',
  private_code: 'الرمز الخاص',
  investor_link: 'رابط المستثمر',
  i_accept_the_lpoa: 'أقبل التوكيل المحدود من محام (LPOA)',
  invest: 'استثمر',
  view_graph: 'عرض الرسم البياني',
  name: 'الاسم',
  search: 'البحث',
  partners: 'الشركاء',
  reject_withdrawls_during_open_trades: 'رفض عمليات السحب أثناء الصفقات المفتوحة',
  private_master_account: 'حساب رئيسي خاص',
  minimum_deposit: 'الحد الأدنى للإيداع',
  performance_fee: 'رسوم الأداء',
  display_name: 'اسم شاشة العرض',
  new_master_account: 'حساب رئيسي جديد',
  pamm_statistics: 'إحصاءات PAMM',
  pamm: 'PAMM',
  volume_traded: 'الحجم المُتداول',
  apply_date_range: 'تطبيق النطاق الزمني',
  pamm_master_locks_deposits: '[تقيد PAMM Master الودائع خلال الصفقات المفتوحة!]',

  // new with vue
  bitcoin: 'Bitcoin',
  register_live_account: 'تسجيل حساب حقيقي',
  register_partner_account: 'تسجيل حساب الشريك',
  register_demo_account: 'تسجيل حساب تجريبي',
  risk_disclosure: 'الكشف عن المخاطرة',
  address_line_2: 'سطر العنوان 2',
  skype_id: 'المعرف الخاص ببرنامج Skype',
  password_rules_extended: 'يجب أن تحتوي كلمة المرور على الأقل على: حرف واحد كبير وحرف واحد صغير ورقم واحد وحرف خاص واحد. يجب أن يتراوح طول كلمة المرور ما بين 8 إلى 16 حرفًا.',
  login_information: 'معلومات تسجيل الدخول',
  director: 'المدير',
  pmethod_visa_mastercard: 'فيزا/ماستركارد',
  pmethod_visa_mastercard_alternative: 'فيزا/ماستركارد.',
  pmethod_bitcoin: 'بيتكوين',
  pmethod_bankwire: 'نظام التحويل البنكي (Bankwire)',
  pmethod_fasapay: 'نظام FasaPay',
  pmethod_ideal: 'نظام iDEAL',
  pmethod_instant_bank_transfer: 'التحويل المصرفي الفوري',
  pmethod_jeton: 'Jeton',
  pmethod_jeton_wallet: 'محفظة Jeton',
  pmethod_my_pay: 'نظام MyPay',
  pmethod_neteller: 'خدمة NETELLER',
  pmethod_vload: 'بطاقة VLOAD',
  pmethod_paykasa: 'Paykasa',
  pmethod_skrill: 'محفظة Skrill',
  pmethod_sofort: 'طريقة الدفع SOFORT',
  pmethod_koalapay: 'KoalaPay',
  pmethod_cup: 'طريقة التسعير (CUP)',
  pmethod_lydiax: 'العملات المشفرة',
  pmethod_safecharge: 'SafeCharge',
  pmethod_trustly: 'التحويل البنكي - Trustly',
  pmethod_powercash: 'PowerCash',
  pmethod_astropay: 'خدمة الدفع AstroPay',
  field_min_currency_value: 'يجب {field} أن يكون الحقل {min} أو أكثر.',
  method_deposit: '{method} الإيداع',
  method_deposit_status: '{method} حالة الإيداع',
  quick_menu: 'القائمة السريعة',
  details: 'التفاصيل',
  date_from: 'التاريخ من',
  date_to: 'التاريخ إلى',
  from: 'من',
  forgot_password_form_instruction: 'يرجى إدخال عنوان البريد الإلكتروني الخاص بحسابك أدناه. ستتلقى بعد ذلك رسالة بريد إلكتروني تحتوي على رابط لإعادة تعيين كلمة المرور الخاصة بك.',
  forgot_password_submit_success_message:
    'تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني. يرجى الرجوع إلى بريدك الإلكتروني ({email}) ومتابعة الرابط لتغيير كلمة المرور الخاصة بك.',
  password_reset_successfully: 'تم إعادة تعيين كلمة المرور الخاصة بك بنجاح',
  password_too_week_or_mismatch: 'كلمة المرور ضعيفة جدًا أو إدخالات كلمات المرور غير متطابقة.',
  withdrawals_credit_card_remaining_amount_message: 'لكي تتمكن من السحب عبر طرق أخرى، يجب عليك أولاً السحب {amount} مرة أخرى إلى بطاقتك الائتمانية.',
  withdrawals_credit_card_refund_policy_message: 'يسمح لك موفرو بطاقات الائتمان فقط بسحب المبلغ الإجمالي الذي أودعته مرة أخرى إلى بطاقتك.',
  withdrawals_amount_withdrawable_message: 'يمكن سحب ما مجموعه {amount} مرة أخرى إلى بطاقتك، ويمكن سحب أي شيء يزيد عن هذا المبلغ بإحدى الطرق الأخرى الخاصة بنا.',
  country_blocked_for_this_method: 'بلدك محظور من استخدام هذه الطريقة',
  copied_text_successfully: 'تم نسخ {text} بنجاح',
  choose_wallet_currency: 'اختر عملة المحفظة',
  pamm_master_account_created_successfully: 'تم إنشاء حساب PAMM Master بنجاح!',
  or_account_no_for_us: 'أو رقم الحساب (لعملاء الولايات المتحدة)',
  issue_date: 'تاريخ الإصدار',
  expiry_date: 'تاريخ الانتهاء',
  full_copy_of_the_document: 'نسخة كاملة من المستند تظهر جميع الزوايا الأربع',
  recent_date: 'تاريخ حديث (لا يزيد عن 3 أشهر)',
  your_physical_address: 'يتطابق عنوانك الفعلي مع العنوان الذي استخدمته عند التسجيل لفتح الحساب',
  must_be_a_utility_bill: 'يجب أن يكون هناك فاتورة مرافق (كهرباء، مياه، هاتف، غاز/طاقة، ضريبة المجلس/فواتير الصرف الصحي) أو كشف حساب مصرفي',
  for_further_info_attach: '**للحصول على مزيد من المستندات، يرجى إرفاقها بالبريد الإلكتروني وإرسالها إلى backoffice@eurotrader.com',
  banners_ad_blocker_notice: 'إذا كنت تواجه مشكلة في عرض اللافتات أدناه، فيرجى تعطيل مانع الإعلانات',
  transfer_out: 'التحويل إلى الخارج',
  transfer_in: 'التحويل إلى الداخل',
  done: 'تمت العملية',
  not_required: 'غير مطلوب',
  wallet_balance: 'رصيد المحفظة:',
  must_agree_terms: 'يجب أن توافق على الشروط والأحكام الخاصة بنا لإنشاء حساب',
  select_payment_method: 'اختر طريقة الدفع',
  islamic_account: 'حساب إسلامي',
  islamic_documents_instructions: 'دليل الإيمان/الدين من المسجد',
  card_number: 'رقم البطاقة',
  expiry: 'الانتهاء',
  redeem: 'استرداد',
  must_be_multiple_of_10: 'يجب أن تكون القيمة من مضاعفات الرقم 10',
  select_starting_balance: 'حدد الرصيد الابتدائي',
  business_name: 'الاسم التجاري',
  business_bank_wire_instructions: 'تعليمات التحويل البنكي للأعمال',

  error_request_failed: 'خطأ: فشل الطلب',
  error_no_user_with_this_email: 'خطأ: لم يتم العثور على حساب بعنوان البريد الإلكتروني هذا',
  error_too_many_password_reset_requests: 'خطأ: تم طلب عدد كبير جدًا من عمليات إعادة تعيين كلمة المرور',
  error_expired_or_invalid_request: 'خطأ: طلب غير صالح أو منتهي الصلاحية',
  error_insufficient_wallet_balance: 'خطأ: رصيد غير كافٍ في المحفظة',
  error_insufficient_balance_or_equity: 'خطأ: رصيد أو رأس مال غير كافٍ',
  error_pamm_master_deposit: 'لا يمكن الإيداع في حساب PAMM Master',
  error_pamm_master_withdrawal: 'لا يمكن السحب من حساب PAMM Master',
  error_pamm_master_locked_deposits: 'مرفوض: PAMM Master الخاصة بالحساب الذي يتم إيداع الأموال فيه ترفض الودائع أثناء الصفقات المفتوحة.',
  error_pamm_master_locked_withdrawals: 'مرفوض: PAMM Master الخاصة بالحساب الذي يتم سحب الأموال منه ترفض عمليات السحب أثناء الصفقات المفتوحة.',
  error_pamm_master_minimum_deposit: 'مرفوض: لم يتم استيفاء الحد الأدنى من متطلبات الإيداع لمنصة PAMM Master.',
  error_live_account_already: 'حسابك هو حساب حقيقي بالفعل',
  error_min_balance_required_is: 'الحد الأدنى للرصيد المطلوب لحساب {TAAccountType} ({TAID}) هو {min}{currency}.',
  error_transfer_same_wallet: 'لا يمكن التحويل من محفظة إلى محفظة.',
  error_transfer_same_trading_account: 'لا يمكن التحويل من وإلى نفس حساب التداول.',
  error_no_deposit_bonus_account_deposit_restricted: 'الإيداعات إلى نوع الحساب "أرباح بدون إيداع" غير مسموح بها.',
  error_no_deposit_bonus_base_amount_withdrawal: 'يتعذر سحب المبلغ الأساسي من "أرباح بدون إيداع".',
  error_no_deposit_bonus_withdraw_profit_requirement_not_met: 'يتعذر سحب "أرباح بدون إيداع" إذا لم يتم استيفاء متطلبات الربح.',
  error_no_deposit_bonus_withdraw_exceeds_max_withdrawable_profit: 'لا يمكن سحب أكثر من الحد الأقصى للربح القابل للسحب.',
  upgrade_required_for_live_ta: 'مطلوب حساب عميل حقيقي ومعتمد قبل أن يمكن فتح حساب تداول حقيقي!',
  error_wallet_currency_not_allowed_for_psp: 'عملة المحفظة غير مسموح لاستخدلمها في طريقة الدفع هذه.',
  error_invalid_or_expired_otp: 'خطأ: كلمة المرور لمرة واحدة (OTP) غير صالحة أو منتهية الصلاحية.',
  error_max_confirmo_withdrawal_exceeded: 'خطأ: الحد الأقصى لطلب سحب التأكيد هو 20000 يورو/دولار أمريكي',
  error_max_anual_vload_withdrawal_exceeded: 'خطأ: تم تجاوز الحد الأقصى لإجمالي طلبات السحب السنوية لبطاقة VLoad',

  // Check for islamic trading account (temporarily disabled)
  is_islamic_acc_message: 'In order to create an Islamic account, please send a request to backoffice@eurotrader.com as to assist you further.',
  error_invalid_voucher: 'خطأ: إيصال بطاقة VLoad غير صالح أو تم استرداده بالفعل',
  error_blocked_voucher: 'خطأ: تم حظر بطاقة VLoad بسبب الاشتباه في وجود احتيال',
  error_voucher_data_mismatch: 'خطأ: تم رفض استخدام بطاقة VLoad بسبب عدم تطابق بيانات الحساب.',
  error_vload_voucher_below_minimum: 'خطأ: إيصال بطاقة VLoad أقل من الحد الأدنى لمبلغ الإيداع.',
  my_bank_has_a_swift_code: 'البك الذي أتعامل معه لديه رمز سويفت',
  my_bank_does_not_have_a_swift_code: 'البنك الذي أتعامل معه ليس لديه رمز سويفت',
  bank_not_in_swift_network_instructions:
    'إذا لم يكن البنك الذي تتعامل معه عضوًا في شبكة SWIFT، فيرجى تزويدنا بالتفاصيل التالية عن البنك المراسل للبنك الذي تتعامل معه لتلقي الحوالات الدولية:',
  correspondent_bank_name: 'اسم البنك المراسل',
  correspondent_bank_city: 'المدينة التي يوجد بها البنك المراسل',
  correspondent_bank_swift: 'رمز سويفت الخاص بالبنك المراسل',

  // New document upload strings
  proof_of_cc: 'Proof of Credit/Debit Card',
  front_of_cc: 'واجهة البطاقة',
  back_of_cc: 'الجزء الخلفي للبطاقة',
  proof_of_cc_instructions: 'يرجى تحميل بطاقة الائتمان أو الخصم الخاصة بك.',
  add_document: 'إضافة مستند (اختياري)',
  cc_requirements_1: 'نسخة كاملة من المستند تظهر جميع الزوايا الأربع.',
  cc_requirements_2: 'الاسم الموجود في البطاقة: يجب إصدار البطاقة التي ستستخدمها باسمك فقط. أي إيداعات تتم باستخدام بطاقة تابعة لطرف خارجي، سيتم إعادتها على الفور.',
  cc_requirements_3: 'تاريخ انتهاء الصلاحية: ما لا يقل عن 3 أشهر.',
  cc_requirements_4: 'رقم البطاقة: يجب تغطية الأرقام الثمانية الوسطى من البطاقة بقطعة من الورق. يجب أن تكون الأرقام الأربعة الأولى والأربعة الأخيرة فقط مرئية.',
  cc_back_requirements_5: 'رمز التحقق من البطاقة (CVC): الرجاء استخدام قطعة من الورق لتغطية رمز التحقق من البطاقة (CVC).',
  cc_back_requirements_6: 'يجب توقيع البطاقة.',
  click_to_add_another_document: 'انقر أعلاه لإضافة مكان تحميل مستند آخر',
  add_up_to_4_extra_documents: 'يمكنك إضافة ما يصل إلى 4 مستندات إضافية',
  add_up_to_10_extra_documents: 'يمكنك إضافة ما يصل إلى 10 مستندات إضافية',
  complete_profile: 'الملف الشخصي كاملاً',
  document_received: 'تم استلام المستند الخاص بك وسيقوم فريقنا بمراجعته.',
  please_check_the_box: 'الرجاء تحديد المربع أدناه.',
  must_be_over_18: 'يجب أن يكون عمرك أكثر من 18 عامًا لتتمكن من التسجيل.',
  shareholders_must_be_over_18: 'يجب أن يكون عمر المساهمين أكثر من 18 عامًا ليتمكنوا من التسجيل.',
  directors_must_be_over_18: 'يجب أن يكون عمر المديرين أكثر من 18 عامًا ليتمكنوا من التسجيل.',
  document_req_color: 'يجب أن يكون المستند ملونًا',
  internal_error: 'حدث خطأ داخلي..',
  please_enter_your_email: 'الرجاء إدخال عنوان البريد الإلكتروني الخاص بك.',
  do_you_want_to_transform_your_trading: 'هل تريد تحويل تداولاتك؟',
  reset_your_password_to_transfer_your_account: 'أعد تعيين كلمة المرور الخاصة بك لنقل حسابك.',
  reset_your_old_password: 'أعد تعيين كلمة المرور القديمة الخاصة بك',
  reset_password_desc: 'نظرًا لتحويل النظام، يلزمك تحديث كلمة المرور الخاصة بك. يرجى استخدام النموذج أدناه لتلقي رابط إعادة تعيين كلمة المرور.',
  eurotrader_login: 'تسجيل الدخول إلى Eurotrader | يمكنك الدخول إلى مركز التداول لرفع مستوى تداولك',
  your_email_is_verified: 'تم التحقق من بريدك الإلكتروني بالفعل.',
  click_here_to_login: 'انقر هنا لتسجيل الدخول',
  success_email_verified: 'تم بنجاح، تم التحقق من بريدك الإلكتروني الآن!',
  your_link_expired: 'انتهت صلاحية الرابط الخاص بك',
  click_here_to_request_verification_email: 'انقر هنا لطلب رسالة تحقق جديدة.',
  a_new_verification_link_send: 'تم إرسال رابط تحقق جديد إلى عنوان بريدك الإلكتروني.',
  invalid_request_please_check_your_link: 'طلب غير صالح. يرجى التحقق من صحة الرابط الخاص بك وحاول مرة أخرى.',
  invalid_verification_code: 'رمز التحقق غير صالح',
  please_enter_amount: 'الرجاء إدخال المبلغ الذي ترغب في إيداعه',
  bankwire_company_desc:
    "<p dir='rtl'>إذا كنت صاحب حساب بنكي تجاري وتريد استخدام خيار التحويل البنكي عن طريق تسجيل حساب عملك معنا، يرجى إرسال المستندات التالية إلينا عبر البريد الإلكتروني backoffice@eurotrader.com</p><ul dir='rtl'><li dir='rtl'>شهادة التأسيس/الشركة</li><li dir='rtl'>شهادة المديرين والسكرتير، إن وجدت</li><li dir='rtl'>شهادة المساهمين المسجلين/ المالك الوحيد.</li><li dir='rtl'>المذكرة والنظام الأساسي، المعروف أيضًا باسم المقالات</li><li dir='rtl'>إثبات الهوية والعنوان لجميع المساهم/المساهمين المسجلين والمالك/المالكين المستفيدين والمدير/المديرين.</li><li dir='rtl'>إثبات العنوان المتعلق بالشركة.</li></ul><p dir='rtl'>يمكن اعتبار أي مستندات حكومية/رسمية أخرى تتحقق من المعلومات المطلوبة أعلاه كافية، في حالة تعذر تقديم المستندات المذكورة أعلاه بهذا الشكل.</p>",
  bankwire_noncompany_desc: "<p dir='rtl'>سيؤدي هذا إلى تسجيل خروجك من حسابك الشخصي وإعادة توجيهك إلى صفحة التسجيل في حساب الشركة.</p><p dir='rtl'>هل ترغب في المتابعة؟</p>",
  please_enter_card_detail_and_amount: 'يُرجى إدخال تفاصيل البطاقة والمبلغ الذي ترغب في إيداعه',
  important: 'مهم',
  please_note_that_the_maximum_deposit_amount: 'يرجى ملاحظة أن الحد الأقصى لمبلغ الإيداع في اليوم هو 1000 دولار لكل بطاقة.',
  city: 'المدينة',
  zip: 'الرمز البريدي',
  please_note_that_after_three_unsuccessful_attempts: '* يرجى ملاحظة أنه بعد ثلاث (3) محاولات غير ناجحة، لن يكون خيار الدفع فيزا/ماستركارد متاحًا لمدة 24 ساعة.',
  epay_pro_desc:
    "<p dir='rtl'>عزيزي المتداول<br/><br/>للأسف، نظرًا لبعض القيود والقيود الفنية، سيتم تعطيل إيداعات بطاقة الائتمان مؤقتًا عبر مزودنا EPayPro.<br/><br/>سيتم تعطيل فيزا وماستركارد في منتصف الليل الساعة 23:00 بتوقيت غرينتش 04/04/2018. بعد تعطيل مقدم الدفع، سيتم تعطيل الإيداعات مؤقتًا. على الرغم من أن موفري الدفع لدينا لم يقدموا لنا إطارًا زمنيًا محددًا لوقت التوقف عن العمل، إلا أننا نعمل على تنفيذ البدائل في أقرب وقت ممكن.<br/><br/>نحن نعمل مع مزودينا لحل المشكلات الحالية بحيث يمكن للحسابات استئناف معالجة الإيداعات في المستقبل دون تأخير.<br/><br/>لا تتردد في الاتصال بفريق الدعم إذا كان لديك أي أسئلة أخرى.</p>",
  provider_redirect: 'سيتم إعادة توجيهك إلى {provider}.',
  lydiax_note: 'الحد الأدنى للإيداع هو 30 يورو/دولار أمريكي',
  lydiax_note1:
    'إذا قمت بإيداع أقل من 30 يورو/دولار أمريكي {crypto}، فستحتاج إلى إرسال بريد إلكتروني إلى backoffice@eurotrader.com، وطلب استرداد الأموال مع توفير {crypto} العنوان الذي ترغب في استرداد الأموال إليه.',
  lydiax_note2: 'الرجاء إدخال المبلغ {crypto} الذي ترغب في إيداعه لمعرفة مقدار ما ستحصل عليه. ضع في اعتبارك أن الأسعار التالية تكون سارية فقط عند طلبها ويمكن تغييرها في أي لحظة.',
  lydiax_note3: 'ستقوم بإنشاء عنوان إيداع لاستخدامه.',
  lydiax_note4: 'الرجاء استخدام العنوان التالي للإيداع {crypto}.',
  lydiax_note5: 'لاحقًا، سيتم استخدام هذا العنوان الفريد لإيداعاتك في {crypto}.',
  lydiax_required_address: 'إذا كانت محفظتك تتطلب العنوان والعلامة بشكل منفصل، فاستخدم:',
  tag: 'العلامة',
  lydiax_enter_deposit: 'الرجاء إدخال العملة المشفّرة التي ترغب في إيداعها',
  create_address: 'إنشاء عنوان',
  please_note: 'يرجى ملاحظة:',
  price_estimate: 'تقدير السعر:',
  check_price: 'التأكد من السعر',
  vload_please_enter_voucher: 'يُرجى إدخال رقم التعريف الشخصي لبطاقة VLOAD',
  vload_minimum: "<p dir='rtl'>(الحد الأدنى المقبول لقيمة القسيمة هو<b dir='rtl'>50</b> يورو أو دولار أمريكي!)</p>",
  vload_vouchers: 'أحتاج إلى شراء بطاقات VLoad',
  vload_note: 'قم بإجراء دفعة بدون أي متاعب عن طريق فيزا/ماستركارد وكذلك التحويل البنكي.<br/>تعرف على المزيد حول VLoad أو قم بشراء بطاقة [يورو/دولار أمريكي] على vload.expert.',
  vload_note1: 'لكي تتمكن من الإيداع عن طريق VLoad، يجب أولاً الموافقة على حسابك!',
  reason: 'السبب:',
  attempts: 'المحاولة {attempts} من {maxAttempts}،',
  two_more_remaining: 'يتبقى محاولتان (2)',
  one_more_remaining: 'محاولة واحدة (1) متبقية فقط',
  please_contact_bank: '<br/>يرجى الاتصال بالبنك الذي أصدر البطاقة.<br/> قد يتم حظر بطاقتك للمعاملات الخارجية',
  edata_success_note:
    'يرجى ملاحظة أنه قد تكون هناك رسوم إضافية على الإيداع الخاص بك، والتي يفرضها البنك المصدر الخاص بك بسبب المعاملة الدولية. ستكون هذه الرسوم صغيرة ولكنها ستختلف من بنك لآخر. <br/><br/>ستظهر معاملة بطاقة الائتمان هذه في بيانك باسم "فواتير خبراء التكنولوجيا" أو "فواتير الأعمال" أو "فواتير وسائط الأعمال".',
  you_can_try: 'يمكنك إعادة المحاولة',
  here: 'هنا',
  safe_charged_success_message: 'سيتم معالجة إيداعك عن طريق مكتب الدعم الخاص بنا في غضون يومي عمل.',
  thank_you: 'شكرًا لك!',
  your_deposit_successful: 'تم الإيداع الخاص بك بنجاح',
  card_redirect: 'ستتم إعادة توجيهك لإدخال بطاقتك الائتمانية وبياناتك الشخصية.',
  bank_wire_withdrawal_note:
    'في حالة رفض التحويل البنكي نيابة عن البنك المتلقي بسبب وجود تفاصيل بنكية خاطئة قدمها العميل، سيتم خصم مصاريف إدارة التحويل البنكي المختلفة التي تتقاضاها البنوك المعنية من مبلغ السحب المطلوب قبل إضافة رصيد إلى محفظة العميل.',
  please_enter_amount_withdraw: 'الرجاء إدخال المبلغ الذي ترغب في سحبه',
  bitcoin_note: 'الرجاء إدخال عنوان البيتكوين الخاص بك والمبلغ الذي ترغب في سحبه',
  otp: 'كلمة المرور لمرة واحدة (OTP)',
  otp_send_email: 'أرسل كلمة المرور لمرة واحدة (OTP) إلى البريد الإلكتروني',
  otp_additional_text: 'كلمة المرور لمرة واحدة (OTP) أعلاه مخصصة لطلب سحب البيتكوين الحالي الذي تقوم به',
  otp_new_password: 'تم إرسال كلمة مرور جديدة لمرة واحدة (OTP) إلى بريدك الإلكتروني',
  otp_error: 'خطأ - فشل إرسال كلمة المرور لمرة واحدة (OTP)',
  lydiax_withdrawal_note:
    'الرجاء إدخال المبلغ {currency} الذي ترغب في سحبه لمعرفة مقدار {crypto} ما ستحصل عليه. ضع في اعتبارك أن الأسعار التالية تكون سارية فقط عند طلبها ويمكن تغييرها في أي لحظة.',
  enter_currency_amount: 'أدخل المبلغ {currency} للتحقق من التقدير',
  lydiax_withdrawal_additional_note: 'كلمة المرور لمرة واحدة (OTP) أعلاه مخصصة لطلب سحب العملات المشفرة الحالية التي تقدمها',
  estimated: 'القيمة المقدرة:',
  please_enter_your_crypto_address: 'يرجى إدخال {crypto} عنوانك والمبلغ المراد سحبه',
  select_cryptocurrency: 'حدد العملة المشفّرة',
  request_amount: 'المبلغ المطلوب',
  amount_changes: 'المبلغ المطلوب سداده (يشمل الرسوم)',
  operation_failed: 'فشلت العملية! كان الطلب غير صالح',
  operation_failed_error: 'فشلت العملية! كان هناك خطأ في معالجة هذا الطلب.',
  are_you_sure_create_master: 'هل أنت متأكد أنك ترغب في إنشاء حساب جديد وإرفاقه تحت هذا الحساب الرئيسي؟',
  are_you_sure_attach_selected_account_to_master: 'هل أنت متأكد من رغبتك في إرفاق الحساب المحدد بهذا الحساب الرئيسي؟',
  change_password_desc:
    "<strong dir='rtl'>*</strong> لن يؤثر تغيير كلمة المرور على كلمات مرور حساب التداول الخاص بك. يرجى زيارة <strong dir='rtl'>قائمة الحسابات</strong> لتغيير كلمات المرور لحساب التداول الخاص بك، باستخدام خيار <strong dir='rtl'>تغيير كلمة المرور</strong> أسفل رمز الترس.",
  client_assessment: 'تقييم العميل',
  select_answer: 'حدد إجابة...',
  declarations: 'الإعلانات',
  complele_profile_desc: 'هل أنت حاليًا متورط، أو سبق لك التورط في أي نشاط إجرامي أو هل هناك أي تهم جنائية معلقة ضدك أمام المحكمة؟',
  complete_profile_desc1:
    'هل أنت أو أحد أقاربك أو المقربين منك شخص معروف سياسياً؟ الأشخاص المعروفين سياسيًا هم الأشخاص الطبيعيون الذين تم تكليفهم بوظائف عامة بارزة خلال الـ 12 شهرًا الماضية، مثل رؤساء الدول أو الحكومات وكبار السياسيين وكبار المسؤولين الحكوميين والقضائيين أو العسكريين وكبار المسؤولين التنفيذيين في الشركات المملوكة للدولة ومسؤولي الأحزاب السياسية المهمين.',
  are_you_us_citizen: 'هل أنت مواطن أمريكي أو مقيم في الولايات المتحدة لأغراض ضريبية؟',
  please_check_forms_errors: 'يرجى التحقق من النماذج لعدم وجود أخطاء!',
  profile_succesfully_completed: 'اكتمل الملف الشخصي بنجاح',
  please_select_country: 'يرجى تحديد بلدك',
  set_country: 'تحديد البلد',
  empty_country_code: 'رمز البلد فارغ، يرجى تحديث الصفحة والمحاولة مرة أخرى.',
  invalid_country_code: 'رمز البلد غير صالح، يرجى تحديث الصفحة والمحاولة مرة أخرى.',
  individual_company: 'هل أنت فرد أم شركة؟',
  prev: 'السابق',
  previous: 'السابق',
  complete: 'مكتمل',
  please_select_an_option: 'يرجى تحديد خيار لكل حقل!',
  swap: 'مبادلة',
  buy: 'شراء',
  sell: 'بيع',
  sums: 'المبالغ',
  net_total: 'الإجمالي الصافي',
  deposit_page_desc:
    '<p class="has-text-white is-size-5-desktop is-size-6-tablet is-size-6-mobile has-text-weight-bold" dir="rtl">سجل الآن و</p><p class="is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-bold vload-promo-large-text" dir="rtl">احصل على قسيمة شراء إلكترونية <span class="has-text-white has-text-weight-bold" dir="rtl"> مجانية </span> <br/> بقيمة 10 يورو/دولار أمريكي<br/></p>',
  deposit_page_desc1: 'سيتم تفعيل قسيمة الشراء الإلكترونية بقيمة 10 يورو/دولار أمريكي بمجرد قيامك بذلك',
  create_new_account: 'إنشاء حساب جديد',
  successfully_purchase_vload: 'شراء قسيمة VLoad الإلكترونية بأي قيمة واستردادها بنجاح',
  upgrade_to_tier_2: 'الترقية إلى المستوى 2',
  register_now: 'سجل الآن',
  back: 'العودة',
  my_card_desc: 'هنا يمكنك رؤية جميع البطاقات التي استخدمتها للمدفوعات وحالتها الحالية في نظامنا.',
  you_have_no_card: 'لم تقم بإجراء أي إيداعات بالبطاقة حتى الآن.',
  card_no: 'رقم البطاقة',
  last_used: 'آخر استخدام',
  risk_warning: 'تحذير من المخاطر',
  upload_documents_note: 'إذا كنت ترغب في إجراء إيداع بالبطاقة، فيرجى تقديم المستندات التالية بالإضافة إلى ذلك ليتم فحصها والموافقة عليها.',
  please_select_your_country: 'يرجى تحديد بلدك أولاً',
  add_another_document: 'أضف مستندًا آخر',
  drop_files_upload: 'قم بإسقاط الملفات هنا للتحميل',
  date_until: 'التاريخ حتى',
  copy: 'نسخ',
  cvv: 'رمز التحقق من البطاقة (CVV)',
  please_enter_crypto_amount: 'أدخل {crypto} المبلغ',
  vload_pin: 'رمز VLoad',
  deposit_info:
    "يواجه مزود المدفوعات حاليًا مشكلات فنية وإيداعات الفيزا/الماستركارد المباشرة غير متوفرة حاليًا. بدلاً من ذلك، إذا كنت ترغب في الإيداع باستخدام الفيزا/الماستركارد، يمكنك استخدام خيار 'Vload'",
  id: 'بطاقة التعريف',
  pamm_modal_error: 'إدخال غير صالح لاسم العرض. يرجى عدم ترك الحقل فارغًا أو إدخال أكثر من 32 حرفًا',
  pamm_modal_error1: 'تم إدخال قيمة غير صحيحة للحد الأدنى للإيداع. يرجى إدخال عدد صحيح موجب أقل من 1,000,000.',
  error_missing_required_field: 'خطأ، حقل مطلوب مفقود',
  page_not_found: 'الصفحة غير موجودة',
  new_version_note: 'تم اكتشاف إصدار جديد، يرجى النقر هنا للتحديث',
  new_version_note1: 'قد لا تتوفر بعض الوظائف حتى تقوم بتحديث الصفحة',
  records: 'السجلات',
  gateway: 'بوابة',

  // Demo Account
  train_up: 'TRAIN UP.',
  trade_up: 'تداول.',
  train_text_1: 'هل أنت مستعد للاستثمار في مستقبلك؟',
  train_text_2: 'ابدأ بحساب تجريبي خالي من المخاطر وتمتع بالوصول إلى موارد التعلم فيEurotrader Academy.',
  train_list_item_1: 'قم بممارسة التداول في بيئة محاكاة.',
  train_list_item_2: 'تمتع بالوصول إلى أفضل موارد التعلم في فئتها.',
  train_list_item_3: 'كن جزءًا من مجتمع Eurotrader.',
  train_list_item_4: 'تذكر: ليس لديك شيء لتخسره، وهناك الكثير لتحصل عليه.',
  form_title_1: 'قم بالتدرب باستخدام',
  form_title_2: 'ميزة',
  form_title_3: 'الحساب التجريبي',
  form_subtitle: 'وتمتع بالوصول إلى مصادر التعلم',
  region: 'منطقة',
  wallet_currency: 'عملة المحفظة',
  select_currency_label: 'عملة حسابك التجريبي',
  join: 'انضم',
  demo_account: 'الحساب التجريبي',
  page_title_demo: 'افتح حسابًا تجريبيًا | Eurotrader',

  // 404 Page
  title_404: 'HEY MONEY, I AM HOME!',
  text_line_1_404: 'ماذا؟ لا أحد هنا لمساعدتك على الاستثمار في مستقبلك؟',
  text_line_2_404: 'دعنا نعود إلى المنزل ونظهر لأموالك مدى قوتك.',
  button_404: 'الرجوع',

  remember_me: 'تذكرني',
  risk_sentence: 'لمعرفة كيف نستخدم بياناتك، يرجى مراجعة',
  video_courses: 'دورات الفيديو التدريبية',
  ebooks: 'الكتب الإلكترونية',

  // Complete Profile
  knowledge_and_experience: 'KNOWLEDGE AND EXPERIENCE',
  economic_profile: 'الوضع الاقتصادي',
  product_governance: 'إدارة المنتج',
  select_an_answer: 'حدد إجابة',
  declarations_q1: 'هل أنت حاليًا متورط، أو سبق لك التورط في أي نشاط إجرامي أو هل هناك أي تهم جنائية معلقة ضدك أمام المحكمة؟',
  declarations_q2:
    'هل أنت أو أحد أقاربك أو المقربين منك شخص معروف سياسياً؟ الأشخاص المعروفين سياسيًا هم الأشخاص الطبيعيون الذين تم تكليفهم بوظائف عامة بارزة خلال الـ 12 شهرًا الماضية، مثل رؤساء الدول أو الحكومات وكبار السياسيين وكبار المسؤولين الحكوميين والقضائيين أو العسكريين وكبار المسؤولين التنفيذيين في الشركات المملوكة للدولة ومسؤولي الأحزاب السياسية المهمين.',
  declarations_q3: 'هل أنت مواطن أمريكي أو مقيم في الولايات المتحدة لأغراض ضريبية؟',

  ca_q1: '1. هل لديك خبرة في التداول؟',
  ca_q2: '2. منذ متى وأنت تستثمر/تتداول في الأسواق المالية؟',
  ca_q3: '3. كم عدد الصفقات التي نفذتها خلال العامين الماضيين؟ <br/>&nbsp;&nbsp; أ. الأسهم ومنتجات الدخل الثابت (الأسهم والسندات)',
  ca_q4: '&nbsp;&nbsp; ب. الفوركس',
  ca_q5: '&nbsp;&nbsp; ج. العقود مقابل الفروقات (CFDs)',
  ca_q6: '&nbsp;&nbsp; د. منتجات المشتقات الأخرى (سند مساهمة، خيارات، حقوق ملكية)',
  ca_q7: '4. ما هو متوسط المبالغ (على أساس شهري) التي استثمرتها في الفئات التالية؟ <br/> &nbsp;&nbsp; أ. الأسهم ومنتجات الدخل الثابت (الأسهم والسندات)',
  ca_q8: '&nbsp;&nbsp; ب. الفوركس',
  ca_q9: '&nbsp;&nbsp; ج. العقود مقابل الفروقات (CFDs)',
  ca_q10: '&nbsp;&nbsp; د. منتجات المشتقات الأخرى (سند مساهمة، خيارات، حقوق ملكية)',
  ca_q11: '5. ما نوع خدمات الاستثمار التي استخدمتها بالفعل؟ (يحتوي على إجابات متعددة)',
  ca_q12: '6. هل ينطبق عليك أي مما يلي؟ (يحتوي على إجابات متعددة)',
  ca_q13:
    '7. يتم تداول سهم Apple بسعر بيع قدره 204 دولارًا وسعر شراء يبلغ 206 دولارًا. وأنت قمت بشراء 100 سهم من Apple بالسعر المذكور أعلاه. ما هو الربح/الخسارة الذي سيكون في حسابك إذا تحرك سعر سهم Apple بسعر بيع 190 دولارًا وسعر الشراء 192 دولارًا وكان عليك إغلاق صفقتك؟',
  ca_q14:
    '8. يتم تداول سهم Apple بسعر بيع قدره 204 دولارًا وسعر شراء قدره 206 دولارًا. وأنت قمت بفتح صفقة شراء على 100 عقد من عقود الفروقات (CFD) (كل عقد يشير إلى سهم واحد من Apple). الرافعة المالية المستخدمة هي 1:5. ما هو الربح/الخسارة الذي سيكون في حسابك إذا تحرك سعر سهم Apple بسعر بيع 190 دولارًا وسعر الشراء 192 دولارًا وكان عليك إغلاق صفقتك؟',
  ca_q15: '9. باستخدام أمر إيقاف الخسارة:',
  ca_q16: '10. رصيد حسابك منخفض. في أي من هذه الحالات قد يُطلب منك إضافة أموال إلى حسابك؟',
  ca_q17:
    '11. يصل سعر شراء مؤشر ستاندرد آند بورز 500 إلى 2700 دولار. وأنت قررت فتح صفقة شراء على عقود فروقات (CFD) تتكون من عقدين. الرافعة المالية المستخدمة هي 1:20. ثم قمت بتعيين أمر إيقاف الخسارة بسعر 2600 دولار وجني الأرباح بسعر 3000 دولار. بافتراض أن الرصيد في حسابك كافٍ وأن الأمر لم يتغير حتى يتم الوصول إلى سعر بيع إيقاف الخسارة أو سعر بيع جني الأرباح ولا يتم تكبد أي رسوم إضافية، فما هو الربح أو الخسارة التي قد تتكبدها في حسابك عندما تغلق الصفقة؟',
  ca_q18: '1. ما هو إجمالي دخلك السنوي؟',
  ca_q19: '2. ما هو مصدر دخلك؟',
  ca_q20: '3. ما هي النسبة المئوية من دخلك السنوي التي تتعلق بالالتزامات المالية؟',
  ca_q21: '4. ما هي القيمة المقدرة لأصولك؟',
  ca_q22: '5. ما هي بنية الأصول الخاصة بك؟',
  ca_q23: '6. ما هو صافي ثروتك المقدرة (إجمالي الأصول - إجمالي الالتزامات المالية)؟',
  ca_q24: '1. يرجى تحديد إحدى العبارات أدناه:',
  ca_q25: '2. أي من العبارات التالية مناسبة لك أكثر؟',
  ca_q26: '3. أيهما أكثر ملائمة لأسلوبك الاستثماري؟',
  ca_q27: '4. بناءً على توقعاتك، ما هو التقلب السنوي في قيمة محفظتك الذي تنوي قبوله؟',
  ca_q28: '5. أي من الخيارات التالية سيعتبر أنسب محفظة لك؟',
  ca_q29: '6. ما هو الافق الزمني لأهدافك الاستثمارية؟',
  ca_q30: '7. ما هو هدفك الاستثماري؟',
  ca_q31: '8. ما هو مستوى السيولة في محفظتك الذي تنوي قبوله؟',

  ca_q1_ao1: 'أ) نعم، لقد قمت بالتداول على حساب حقيقي',
  ca_q1_ao2: 'ب) نعم، لقد قمت بالتداول على حساب تجريبي',
  ca_q1_ao3: 'ج) لا، لكني استخدمت خدمات الاستثمار الخاصة بإدارة المحافظ و/أو نصائح الاستثمار',
  ca_q1_ao4: 'د) لا، ولكن لدي معرفة واسعة من خلال تعليمي (درجة البكالوريوس، درجة الماجستير، إلخ)',
  ca_q1_ao5: 'هـ) لا',
  ca_q2_ao6: 'أ) 0 - 6 أشهر',
  ca_q2_ao7: 'ب) 6 - 12 شهرًا',
  ca_q2_ao8: 'ج) 1 - 2 سنوات',
  ca_q2_ao9: 'د) 2 - 4 سنوات',
  ca_q2_ao10: 'هـ) أكثر من 4 سنوات',
  ca_q3_ao11: '1. أبدًا',
  ca_q3_ao12: '2. نادرًا (أقل من 50 مرة)',
  ca_q3_ao13: '3. أحيانًا (50-100 مرة)',
  ca_q3_ao14: '4. كثيرًا (أكثر من 101 صفقة)',
  ca_q4_ao15: '1. أبدًا',
  ca_q4_ao16: '2. نادرًا (أقل من 50 مرة)',
  ca_q4_ao17: '3. أحيانًا (50-100 مرة)',
  ca_q4_ao18: '4. كثيرًا (أكثر من 101 صفقة)',
  ca_q5_ao19: '1. أبدًا',
  ca_q5_ao20: '2. نادرًا (أقل من 50 مرة)',
  ca_q5_ao21: '3. أحيانًا (50-100 مرة)',
  ca_q5_ao22: '4. كثيرًا (أكثر من 101 صفقة)',
  ca_q6_ao23: '1. أبدًا',
  ca_q6_ao24: '2. نادرًا (أقل من 50 مرة)',
  ca_q6_ao25: '3. أحيانًا (50-100 مرة)',
  ca_q6_ao26: '4. كثيرًا (أكثر من 101 صفقة)',
  ca_q7_ao27: '1. 0',
  ca_q7_ao28: '2. أقل من 500 يورو',
  ca_q7_ao29: '3. 501 يورو - 2,000 يورو',
  ca_q7_ao30: '4. 2,001 يورو - 5,000 يورو',
  ca_q7_ao31: '5. أكثر من 5,001 يورو',
  ca_q8_ao32: '1. 0',
  ca_q8_ao33: '2. أقل من 500 يورو',
  ca_q8_ao34: '3. 501 يورو - 2,000 يورو',
  ca_q8_ao35: '4. 2,001 يورو - 5,000 يورو',
  ca_q8_ao36: '5. أكثر من 5,001 يورو',
  ca_q9_ao37: '1. 0',
  ca_q9_ao38: '2. أقل من 500 يورو',
  ca_q9_ao39: '3. 501 يورو - 2,000 يورو',
  ca_q9_ao40: '4. 2,001 يورو - 5,000 يورو',
  ca_q9_ao41: '5. أكثر من 5,001 يورو',
  ca_q10_ao42: '1. 0',
  ca_q10_ao43: '2. أقل من 500 يورو',
  ca_q10_ao44: '3. 501 يورو - 2,000 يورو',
  ca_q10_ao45: '4. 2,001 يورو - 5,000 يورو',
  ca_q10_ao46: '5. أكثر من 5,001 يورو',
  ca_q11_ao47: 'أ. استقبال ونقل و/أو تنفيذ الأوامر (خدمات الاستثمار التي تتطلب قرارات مستقلة)',
  ca_q11_ao48: 'ب. نصائح استثمارية',
  ca_q11_ao49: 'ج. إدارة المحافظ',
  ca_q11_ao50: 'د. لا شيء',
  ca_q12_ao51: 'أ. لدي خبرة مهنية ذات صلة',
  ca_q12_ao52: 'ب. أنا أراقب الأخبار/الأسواق بانتظام',
  ca_q12_ao53: 'ج. لقد حضرت ندوة أو دورة تدريبية تتعلق بالأسواق المالية / الاستثمارات / التداول عبر الإنترنت',
  ca_q12_ao54: 'د. لا شيء مما سبق',
  ca_q13_ao55: 'أ. 1,200- يورو',
  ca_q13_ao56: 'ب. 1,400- يورو',
  ca_q13_ao57: 'ج. 1,600- يورو',
  ca_q13_ao58: 'د. 1,800- يورو',
  ca_q14_ao59: 'أ. 6,000- يورو',
  ca_q14_ao60: 'ب. 7,000- يورو',
  ca_q14_ao61: 'ج. 8,000- يورو',
  ca_q14_ao62: 'د. 10,000- يورو',
  ca_q15_ao63: 'أ. يحميك من تكبد الخسائر السريعة',
  ca_q15_ao64: 'ب. يحد من تعرضك للمخاطر',
  ca_q15_ao65: 'ج. يضمن لك عدم خسارة أي صفقة',
  ca_q15_ao66: 'د. يحميك من مخاطر استخدام الرافعة المالية',
  ca_q16_ao67: 'أ. إذا كان سعر الأصل الأساسي في الصفقة المفتوحة سار عكس توقعك وتحركت قيمة رأس مالك إلى ما دون الحد الأدنى لهامش الصيانة.',
  ca_q16_ao68: 'ب. إذا تكبدت رسوم معاملات أدت إلى عجز حسابك.',
  ca_q16_ao69: 'ج. إذا كانت صفقة العقود مقابل الفروقات المفتوحة تتكبد رسومًا ليلية مما يضع حسابك في حالة عجز.',
  ca_q16_ao70: 'د. كل ما سبق.',
  ca_q17_ao71: 'أ. 100- دولار أو 300 دولار',
  ca_q17_ao72: 'ب. 200- دولار أو 600 دولار',
  ca_q17_ao73: 'ج. 2,000- دولار أو 6,000 دولار',
  ca_q17_ao74: 'د. 4,000- دولار أو 12,000 دولار',
  ca_q18_ao75: 'أ. أقل من 20,000 يورو',
  ca_q18_ao76: 'ب. بين 20,000 يورو و50,000 يورو',
  ca_q18_ao77: 'ج. بين 50,000 يورو و100,000 يورو',
  ca_q18_ao78: 'د. أكثر من 100,000 يورو',
  ca_q19_ao79: 'أ. الراتب/ المعاش',
  ca_q19_ao80: 'ب. توزيعات الأرباح/ الفوائد/ القسائم',
  ca_q19_ao81: 'ج. الإيجارات',
  ca_q19_ao82: 'د. التبرعات/ الميراث',
  ca_q19_ao83: 'هـ. مصدر دخل آخر',
  ca_q20_ao84: 'أ. أقل من 25%',
  ca_q20_ao85: 'ب. بين 25% و50%',
  ca_q20_ao86: 'ج. بين 50% و75%',
  ca_q20_ao87: 'د. أكثر من 75%',
  ca_q21_ao88: 'أ. أقل من 100,000 يورو',
  ca_q21_ao89: 'ب. بين 100,000 يورو و500,000 يورو',
  ca_q21_ao90: 'ج. بين 500,000 يورو و1,000,000 يورو',
  ca_q21_ao91: 'د. أكثر من 1,000,000 يورو',
  ca_q22_ao92: 'أ. في الودائع المصرفية بشكل أساسي',
  ca_q22_ao93: 'ب. في العقارات بشكل أساسي',
  ca_q22_ao94: 'ج. في الأدوات المالية بشكل أساسي',
  ca_q22_ao95: 'د. يتم تخصيصها بالتساوي في جميع الخيارات الثلاثة المذكورة أعلاه',
  ca_q22_ao96: 'هـ. غير ذلك',
  ca_q23_ao97: 'أ. أقل من 100,000 يورو',
  ca_q23_ao98: 'ب. بين 100,000 يورو و500,000 يورو',
  ca_q23_ao99: 'ج. بين 500,000 يورو و1,000,000 يورو',
  ca_q23_ao100: 'د. أكثر من 1,000,000 يورو',
  ca_q24_ao101: 'أ. أنا أتحمل المخاطر التي قد تقلل من رأس مالي المستثمر فقط في ظل الظروف القصوى.',
  ca_q24_ao102: 'ب. يمكنني المخاطرة بجزء من رأس مالي المستثمر من أجل الوصول إلى عائد أعلى من المتوسط.',
  ca_q24_ao103: 'ج. يمكنني المخاطرة بجزء من رأس مالي المستثمر أو كله، على أمل أن أحصل على عوائد أعلى.',
  ca_q25_ao104: 'أ. أهم شيء بالنسبة لي هو المحافظة على رأس مالي. وبالتالي، فأنا على استعداد للتخلي عن العوائد الأعلى من أجل تجنب أي خسارة',
  ca_q25_ao105: 'ب. من أجل الحصول على عوائد أعلى من المتوسط، أقبل تحمل مخاطر أعلى وأنا مستعد لقبول الانخفاض الطفيف في رأس مالي.',
  ca_q25_ao106: 'ج. للحصول على عوائد عالية، فأنا على استعداد لتحمل مخاطر عالية حتى لو كان جزء من رأس مالي أو كله معرضًا للخطر.',
  ca_q26_ao107: 'أ. المحافظة على رأس المال',
  ca_q26_ao108: 'ب. نمو الدخل',
  ca_q26_ao109: 'ج. المضاربة',
  ca_q26_ao110: 'د. التحوط',
  ca_q27_ao111: 'أ. ± 5%',
  ca_q27_ao112: 'ب. ± 10%',
  ca_q27_ao113: 'ج. ± 25%',
  ca_q27_ao114: 'د. ± 50%',
  ca_q28_ao115: 'أ. الاختيار الذي سينتج عائدًا ثابتًا بنسبة 1 - 2% في السنوات القادمة.',
  ca_q28_ao116: 'ب. الاختيار الذي سينتج عوائد بين -2% و+10% في السنوات القادمة.',
  ca_q28_ao117: 'ج. الاختيار الذي من المتوقع أن ينتج عوائد بين -15% و+30% في العام المقبل وقد يؤدي إلى خسارة تتجاوز المبلغ المستثمر في ظل الظروف القصوى.',
  ca_q29_ao118: 'أ. تصل إلى 1 سنة',
  ca_q29_ao119: 'ب. بين 1 و3 سنوات',
  ca_q29_ao120: 'ج. بين 3 و5 سنوات',
  ca_q29_ao121: 'د. أكثر من 5 سنوات',
  ca_q30_ao122: 'أ. إدارة السيولة قصيرة الأجل لتغطية النفقات غير المتوقعة.',
  ca_q30_ao123: 'ب. مدخرات طويلة الأجل.',
  ca_q30_ao124: 'ج. تحقيق أرباح عالية حتى مع المخاطرة بخسارة المبلغ المستثمر',
  ca_q31_ao125: 'أ. أقل من 25%',
  ca_q31_ao126: 'ب. بين 25% و50%',
  ca_q31_ao127: 'ج. بين 50% و75%',
  ca_q31_ao128: 'د. أكثر من 75%',

  passport_ple_different: 'في حالة اختلاف بلد إقامتك عن بلد إصدار بطاقة الهوية الخاصة بك، يرجى تحميل جواز السفر الخاص بك.',

  live_account: 'حساب حقيقي',
  agree_terms_marketing: 'أوافق على تلقي تحديثات التسويق من Eurotrader (عرض <a href="{PRIVACY_URL}" target="_blank" dir="rtl">سياسة الخصوصية</a> ).',
  data_policy_text:
    'بياناتك بمأمن معنا، ويمكنك إلغاء الاشتراك في أي وقت. بالنقر أدناه، أنت تؤكد أنك قد قرأت ووافقت على <a href="{TERMS_CONDITIONS_URL}" target="_blank" dir="rtl">الشروط والأحكام</a> و<a href="{RISK_DISCLOSURE_URL}" target="_blank" dir="rtl"> كشف المخاطر</a> وتوافق على قيامنا بتخزين معلوماتك الشخصية ومعالجتها.',
  live_tos_with_link: 'لقد قرأت وفهمت وقبلت الشروط والأحكام وكشف تحذير المخاطر <a href="{URL}" target="_blank" dir="rtl">هنا</a>.',
  must_agree_marketing_terms: 'يرجى تحديد خانة الاختيار للمتابعة إلى الخطوة التالية',
  tick_checkboxes: 'يرجى تحديد خانات الاختيار للمتابعة',
  partner_account: 'حساب الشريك',
  privacy_policy: 'سياسة الخصوصية',
  client: 'عميل',
  commission_amount: 'مبلغ العمولة',
  tier_name: 'اسم المستوى',
  trades_completed: 'الصفقات المكتملة',
}



// WEBPACK FOOTER //
// ./src/locale/ar.js